import Sidebar from '../utill/Sidebar'
import Header from "../utill/Header";
import Footer from "../utill/Footer";
import {Card, Form, Table} from "react-bootstrap";
import React, {ChangeEvent, useContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import Url from "../utill/Url";
import {useSelector} from "react-redux";
import {reissue} from "../utill/UtilComponent";
import styles from "../../css/Authority.module.css";
import {RootState} from "../../redux/store";

function ClientAdd() {
    const url = useContext(Url)
    const navigate = useNavigate();
    const nowUser = useSelector((state: RootState) => state.user.value);
    const [customerCode, setCustomerCode] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [description, setDescription] = useState('');
    const [disable, setdisable] = useState(true);

    let userId = nowUser.id;
    const auth = useSelector((state: RootState) => state.loginAuth.value);

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-고객사 등록'
        if (auth.MENUAUTH?.SET0200?.readAuthorityYn !== "1" && auth.MENUAUTH?.SET0200?.writeAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate(auth.firstUrl);
        }
        else if (auth.MENUAUTH?.SET0200?.writeAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다')
            navigate('/ClientManagement')
        }
    }, [])

    const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
        reissue(userId, url, navigate).then(() => {
            e.preventDefault();
            const isAction = window.confirm('등록 하시겠습니까?');
            if (isAction) {
                try {
                    axios.post(url + 'customercode/create', {
                        customerCode: customerCode,
                        customerName: customerName,
                        description: description,
                        loginId: nowUser.id
                    }, {
                        headers: {
                            'Authorization': localStorage.getItem('Authorization')
                        }
                    }).then(() => {
                            alert('사용자 등록 완료');
                            navigate('/ClientManagement');
                        }
                    )
                } catch (e) {
                    console.error(e);
                }
            }
        })
    };

    const handlecheck = () => {
        reissue(userId, url, navigate).then(() => {
            if (!customerCode) {
                alert('고객사 코드를 입력하세요');
            } else {
                axios.get(url + `customercode/ischeck`, {
                    headers: {
                        'Authorization': localStorage.getItem('Authorization')
                    },
                    params: {
                        customerCode: customerCode
                    }
                })
                    .then(response => {
                        if (response.data.code === 200) {
                            alert('사용 가능한 코드입니다.');
                            setdisable(false);
                        } else {
                            alert('이미 사용중인 코드 입니다.');
                            setdisable(true);
                        }
                    })
                    .catch(error => {
                        console.error('코드 중복 확인 실패:', error);
                    });
            }
        })
    };

    const customerCodeChange = (e: ChangeEvent<HTMLInputElement>) => {
        setdisable(true)
        setCustomerCode(e.target.value);
    };
    const customerNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        setCustomerName(e.target.value);
    };
    const descriptionChange = (e: ChangeEvent<HTMLInputElement>) => {
        setDescription(e.target.value);
    };

    const handleModifyCancel = () => {
        const Cancel = window.confirm('취소하시겠습니까? 입력중인 내용이 모두 삭제됩니다.');
        if (Cancel) {
            navigate('/ClientManagement');
        }
    }

    return (
        <div id="wrapper">
            <Sidebar menuCode={"SET0200"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='고객사 등록'/>
                        <Card className="card shadow mb-4">
                            <Card.Body style={{margin:'1rem'}}>
                                    <Table bordered>
                                        <p style={{fontSize:'14px',marginBottom:'10px'}} className="before_required">표시는 필수 입력 항목입니다.</p>
                                        <tbody>
                                        <tr>
                                            <td style={{width:"30%"}} className={styles.tableHead}><p className="after_required">고객사 코드</p></td>
                                            <td style={{width: "80%"}}>
                                                <Form.Control type="text" placeholder="고객사 코드" name="clientCode"
                                                              onChange={customerCodeChange}/>
                                                <button className="btn btn-primary"
                                                        onClick={handlecheck} style={{marginLeft:'1rem'}} type="submit">중복 체크
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{width: "30%"}} className={styles.tableHead}><p className="after_required">고객사 명</p></td>
                                            <td style={{width:"80%"}}>
                                                <Form.Control type="text" placeholder="고객사 명" name="clientName" onChange={customerNameChange}/></td>
                                        </tr>
                                        <tr>
                                            <td style={{width:"30%", verticalAlign: "middle"}} className={styles.tableHead}><p>설명</p>
                                            </td>
                                            <td style={{width:"80%"}}>
                                                <Form.Control type="text" placeholder="설명" as="textarea" name="Explanation" style={{height:"10rem"}} onChange={descriptionChange}/></td>
                                        </tr>
                                        </tbody>
                                    </Table>
                                    <div className="btn modify">
                                        <button className="btn btn-primary" disabled={disable}
                                                onClick={handleSubmit} type="submit">등록
                                        </button>
                                        <button className="btn btn-secondary" onClick={handleModifyCancel}>취소
                                        </button>
                                    </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    )
}

export default ClientAdd;